import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/Card"; // Adjust the import path as needed

const ResearchCard = ({ title, description, tags }) => (
  <Card className="bg-white dark:bg-red-800 shadow-lg hover:shadow-xl transition-shadow h-full">
    <CardHeader>
      <CardTitle className="text-xl font-semibold">{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="flex flex-wrap gap-2 mt-2">
        {tags.map((tag, index) => (
          <span
            key={index}
            className="px-2 py-1 bg-red-100 dark:bg-red-300 text-gray-50 text-sm rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default ResearchCard;
